'use client';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { logError } from "../console/logError.js";
import { visuallyHidden } from "../../../css-utils.js";
import { liveAreaLabel } from "./useLiveAnnouncement.data.js";
const announcer = new class Announcer {
  constructor() {
    __publicField(this, "REPOPULATION_TIMEOUT", 100);
    // value recommended by https://inclusive-components.design/tooltips-toggletips/
    __publicField(this, "containerEl");
    // if screen-reader would ever reach the live announcement then containerEl will provide the context
    __publicField(this, "elMap", /* @__PURE__ */ new Map());
    __publicField(this, "announce", (msg, optionsRaw) => {
      const options = this.processOptions(optionsRaw);
      this.cleanup(options.id);
      if (msg === null) return;
      this.prepare(options).then(() => this.insertText(msg, options)).catch(logError);
    });
  }
  cleanup(id) {
    var _a;
    const el = this.elMap.get(id);
    (_a = el == null ? void 0 : el.parentElement) == null ? void 0 : _a.removeChild(el);
  }
  processOptions(options) {
    this.initContainerIfNeeded();
    return {
      id: options.id,
      role: options.a11yImportance === "assertive" ? "alert" : "status",
      parent: options.parent || this.containerEl
    };
  }
  insertText(msg, { id }) {
    const el = this.elMap.get(id);
    el.textContent = msg;
  }
  prepare(options) {
    const el = document.createElement("div");
    this.elMap.set(options.id, el);
    el.setAttribute("role", options.role);
    options.parent.appendChild(el);
    return new Promise((resolve) => {
      window.setTimeout(resolve, this.REPOPULATION_TIMEOUT);
    });
  }
  initContainerIfNeeded() {
    if (this.containerEl) return;
    this.containerEl = document.createElement("div");
    this.containerEl.setAttribute("role", "group");
    const labelId = "chalk-live-area-label";
    const labelEl = document.createElement("div");
    labelEl.textContent = liveAreaLabel;
    labelEl.setAttribute("id", labelId);
    labelEl.setAttribute("aria-hidden", "true");
    this.containerEl.appendChild(labelEl);
    this.containerEl.setAttribute("aria-labelledby", labelId);
    this.containerEl.setAttribute("class", visuallyHidden);
    document.body.appendChild(this.containerEl);
  }
}();
function useLiveAnnouncement() {
  return announcer.announce;
}
export {
  useLiveAnnouncement
};
